export default {
  eyebrow: 'Portal do parceiro',
  title: 'Identidade visual',
  description: 'O aspeto do seu portal white-label e página de início de sessão.',
  page: {
    read_only_notice: 'Só de leitura. Clique em Editar para alterar qualquer valor.',
    editing_notice: 'A editar — as alterações são visíveis para a sua equipa e clientes.',
  },
  branding: {
    scope_hint:
      'Aplica-se ao seu portal white-label e página de início de sessão — não às montras dos seus restaurantes, que têm identidade visual própria por restaurante.',
    upload: 'Carregar logótipo',
    logo: {
      label: 'Logótipo',
      hint: 'Exibido nas suas superfícies white-label.',
    },
    circle_logo: {
      label: 'Favicon / logótipo circular',
      hint: 'Logótipo quadrado usado como favicon e avatar. Opcional — pode ser removido.',
    },
    splash_image: {
      label: 'Imagem de início de sessão',
      hint: 'Exibida na sua página de início de sessão white-label. Recomendado: pelo menos 1200px de largura. Opcional — pode ser removida.',
    },
    footer_note: 'Mais opções de identidade visual (cores secundárias) disponíveis em breve.',
  },
  form: {
    primary_color: {
      label: 'Cor principal da marca',
      hint: 'Define o tema do seu portal de parceiro e início de sessão.',
    },
    dashboard_subdomain: {
      label: 'Slug de início de sessão do parceiro',
      hint: 'Slug em minúsculas — identifica a sua marca na ligação de início de sessão da equipa (?partner=…).',
      placeholder: 'nome-do-parceiro',
    },
    login_url: {
      label: 'Ligação de início de sessão da equipa',
      hint: 'Partilhe esta ligação com a sua equipa — abre a página de início de sessão com a sua identidade visual.',
    },
    file: {
      label: 'Imagem',
    },
  },
  login_url_warning: {
    title: 'Alterar a ligação de início de sessão da equipa?',
    description:
      'A ligação de início de sessão da equipa passará a ser {{url}}. Partilhe a nova ligação a partir de agora — a antiga deixa de mostrar a sua marca.',
    description_no_url:
      'A ligação de início de sessão da equipa será alterada. Partilhe a nova ligação a partir de agora — a antiga deixa de mostrar a sua marca.',
  },
  login_url_changed: {
    title: 'Ligação de início de sessão da equipa alterada',
    description:
      'A sua equipa passa a iniciar sessão em {{url}}. Guarde a nova ligação nos favoritos e partilhe-a com a sua equipa.',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'Não foi possível carregar a sua identidade visual.',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
    logo_uploaded: 'Logótipo carregado',
    logo_upload_failed: 'Falha ao carregar o logótipo',
    logo_removed: 'Logótipo removido',
    logo_remove_failed: 'Falha ao remover o logótipo',
    file_too_large: 'Ficheiro demasiado grande. O tamanho máximo é {{max}} MB.',
    image_too_narrow: 'A imagem de início de sessão deve ter pelo menos {{min}}px de largura.',
  },
};
